import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UserDirectSaveWrongRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserDirectSaveWrong = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, UserDirectSaveWrongRequest>()

  return {
    ...mutation,
    mutateAsync: async (data: UserDirectSaveWrongRequest) => {
      const result = await mutation.mutateAsync({
        url: '/user/saveDirectWrong',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['userDirectWrong', data.USER_ID] })
      return result
    },
    mutate: (data: UserDirectSaveWrongRequest) => {
      mutation.mutate(
        {
          url: '/user/saveDirectWrong',
          data,
        },
        {
          onSuccess: () => {
            const userId = data.USER_ID;
            return queryClient.invalidateQueries({ queryKey: ['userWrong'] });
          },
        }
      )
    },
  }
}
